import React, { useState } from "react";
import _ from "lodash";
import {
  Box,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
  Avatar,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useNavigate } from "react-router-dom";
import "./CategoryIndex.css";
import { Pagination } from "@mui/material";
import Topics from "./topics/Topics";
import { paginate } from "../../utils/paginate";

// Styles..
const useStyles = makeStyles({
  table: {
    width: "48%",
    border: "2px solid transparent",
    marginRight: "4px",
  },
  colorOrange: {
    color: "#fe7a15 !important",
  },
  container: {
    marginTop: "2rem",
    border: "none",
    display: "flex",
  },
  userInfoContainer: {
    display: "flex",
    alignItems: "center",
    marginBottom: "8px",
  },
  avatar: {
    width: "32px",
    height: "32px",
    marginRight: "8px",
  },
});

// Comments of table..
const CommentsTable = ({ categoriesData, latestData }) => {
  const navigate = useNavigate();
  const classes = useStyles();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(6);

  const pagesCount = Math.ceil(categoriesData.length / pageSize);

  const opencomment = (id) => {
    navigate(`/forum/forums/${id}`);
  };

  const getCategoryPgnation = () => {
    let nCategory = paginate(categoriesData, currentPage, pageSize);
    return { data: nCategory };
  };

  const getTopicsPgnation = () => {
    let nTopics = paginate(latestData, currentPage, pageSize);
    return { data: nTopics };
  };

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

  // Returning statement..
  return (
    <Box backgroundColor="red">
      <Box marginLeft="1%">
        <TableContainer className={classes.container} component={Paper}>
          {/* ---- 1st part of table ---- */}
          <Table className={classes.table}>
            <TableHead>
              <TableRow
                style={{
                  borderBottom: "3px solid lightgray",
                  borderLeft: "none",
                }}
              >
                <TableCell
                  width="75%"
                  style={{
                    color: "#a9a9a9",
                    fontWeight: "600",
                    fontSize: "0.7rem",
                  }}
                >
                  Categories
                </TableCell>
                <TableCell
                  align="center"
                  style={{
                    color: "#a9a9a9",
                    fontWeight: "600",
                    fontSize: "0.7rem",
                  }}
                >
                  Latest
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {categoriesData.length > 0 &&
                getCategoryPgnation().data.map((comment, index) => (
                  <TableRow key={comment._id} style={{ height: "140px" }}>
                    <TableCell
                      style={{ borderLeft: `solid 7px ${comment.color}` }}
                    >
                      <Box onClick={() => opencomment(comment._id)}>
                        <Box
                          display="flex"
                          flexDirection="column"
                          justifyContent="space-between"
                          style={{ cursor: "pointer" }}
                        >
                          <Box className={classes.userInfoContainer}>
                            {comment?.user?.imageSrc && (
                              <Avatar 
                                src={comment.user.imageSrc} 
                                className={classes.avatar}
                                alt={`${comment?.user?.contactName?.first || ''} ${comment?.user?.contactName?.last || ''}`}
                              />
                            )}
                            <Typography variant="body1">
                              {comment?.user?.contactName?.first} {comment?.user?.contactName?.last}
                            </Typography>
                          </Box>
                          
                          <Typography variant="h4">{comment.name}</Typography>
                          <Typography variant="body1">
                            {comment.description}
                          </Typography>
                        </Box>
                      </Box>
                    </TableCell>

                    <TableCell align="center">
                      <div style={{ color: "lightgray", fontWeight: "600" }}>
                        1/week
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>

          {/* ----- 2nd Part of table ----- */}
          <Table className={classes.table}>
            <TableHead>
              <TableRow
                style={{
                  borderBottom: "3px solid lightgray",
                  borderLeft: "none",
                }}
              >
                <TableCell
                  width="80%"
                  style={{
                    color: "#a9a9a9",
                    fontWeight: "600",
                    fontSize: "0.7rem",
                  }}
                >
                  Topics
                </TableCell>
                <TableCell
                  width="5%"
                  style={{
                    color: "#a9a9a9",
                    fontWeight: "600",
                    fontSize: "0.7rem",
                  }}
                >
                  Views
                </TableCell>
                <TableCell
                  width="15%"
                  style={{
                    color: "#a9a9a9",
                    fontWeight: "600",
                    fontSize: "0.7rem",
                  }}
                >
                  Replies
                </TableCell>
              </TableRow>
            </TableHead>

            {/* ---- Latest Data ---- */}
            <TableBody>
              <Topics
                latestData={latestData}
                getTopicsPgnation={getTopicsPgnation}
              />
            </TableBody>
          </Table>
        </TableContainer>

        {/*--------- Pagination here --------*/}
        <div className="paginationContainer">
          <Pagination
            count={pagesCount}
            page={currentPage}
            color="primary"
            onChange={handlePageChange}
          />
        </div>
      </Box>
    </Box>
  );
};

export default CommentsTable;
